import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'

import { environment } from '../../../environments/environment'
import { ImageSet } from '../interfaces/image-set.interface'

@Injectable({
  providedIn: 'root'
})
export class MediaService {
  constructor(private http: HttpClient) {}

  upload(resourceName: string, fileContent: any): Promise<any> {
    const formData = new FormData()

    formData.append('file', fileContent)
    formData.append('resourceName', resourceName)

    return this.http
      .post(`${environment.apiCatalogBaseUrl}upload/image`, formData)
      .toPromise()
  }

  getImageSet(imageId: number): Promise<ImageSet> {
    return this.http
      .get(`${environment.apiBlogBaseUrl}media/${imageId}`)
      .toPromise()
      .then((response: any) => {
        const sizes = response?.media_details?.sizes

        if (!sizes) {
          return null
        }

        const imageSet: ImageSet = {}

        Object.keys(sizes).forEach((key: string) => {
          imageSet[key] = sizes[key].source_url
        })

        return imageSet
      })
  }
}
